"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";
import Link from "next/link";
import { ChevronDown, Navigation2, Trees } from "lucide-react";
import { IBanner } from "@/store/home/homeModel";
import { OptimizedImage } from "@/components/common/OptimizedImage";

const HomeBannerSlider = ({ data }: { data: any[] }) => {
  return (
    <>
      {data?.length > 1 && (
        <div className={`banner-navigation-btn`}>
          <div className="swiper-button-prev banner-custom-prev"></div>
          <div className="swiper-button-next banner-custom-next"></div>
        </div>
      )}
      <Swiper
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
        slidesPerView={1}
        navigation={{
          nextEl: ".banner-custom-next",
          prevEl: ".banner-custom-prev",
        }}
        modules={[Autoplay, Navigation]}
        className="h-[100dvh] w-full"
      >
        {data?.map((slide: IBanner, index: number) => (
          <SwiperSlide key={index}>
            <div className="relative h-[100dvh] w-full flex items-center justify-center overflow-hidden bg-gray-900">
              <div
                className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/30 to-black/60 z-10"
                style={{ pointerEvents: "none" }}
              />
              <div
                className="absolute inset-0"
                style={{ pointerEvents: "none" }}
              >
                <OptimizedImage
                  src={slide?.BannerImage}
                  alt={slide.BannerTitle}
                  fill
                  priority={index === 0}
                  sizes="100vw"
                  className="object-cover animate-slow-zoom"
                />
              </div>
              <div className="relative z-20 text-center px-6 max-w-6xl w-full flex flex-col items-center justify-center min-h-[500px]">
                <div className="flex flex-col items-center justify-center h-full">
                  {index === 0 ? (
                    <h1 className="text-4xl md:text-6xl text-white mb-6 drop-shadow-2xl font-bold min-h-[1.2em]">
                      {slide.BannerTitle}
                    </h1>
                  ) : (
                    <h2 className="text-4xl md:text-6xl text-white mb-6 drop-shadow-2xl font-bold min-h-[1.2em]">
                      {slide.BannerTitle}
                    </h2>
                  )}
                  <p className="text-white/95 text-xl md:text-3xl mb-4 leading-relaxed max-w-3xl mx-auto drop-shadow-lg font-light tracking-wide min-h-[3em] flex items-center justify-center">
                    {slide.SubTitle}
                  </p>
                  <p className="text-white/90 text-lg md:text-xl mb-12 leading-relaxed max-w-3xl mx-auto drop-shadow-md font-light min-h-[3em] flex items-center justify-center">
                    {slide.Description}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-5 justify-center items-center h-[70px]">
                    <Link href="/contact/">
                      <button className="bg-gradient-to-r from-[#E07A2F] to-[#c96a28] text-white px-10 py-5 rounded-full hover:shadow-2xl transition-all hover:scale-105 flex items-center gap-3 text-lg group whitespace-nowrap">
                        <Trees className="w-6 h-6 group-hover:rotate-12 transition-transform" />
                        Plan Your Stay
                      </button>
                    </Link>
                    <Link href="/activities/">
                      <button className="bg-white/10 backdrop-blur-md border-2 border-white/50 text-white px-10 py-5 rounded-full hover:bg-white/20 transition-all flex items-center gap-3 text-lg group whitespace-nowrap">
                        <Navigation2 className="w-6 h-6 group-hover:translate-x-1 transition-transform rotate-45" />
                        Explore the Forest
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
                <ChevronDown
                  className="w-8 h-8 text-white/60 cursor-pointer"
                  style={{ pointerEvents: "all" }}
                  onClick={() => {
                    window.scrollBy({
                      top: window.innerHeight,
                      behavior: "smooth",
                    });
                  }}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default HomeBannerSlider;
